import {AllItemsPerPage} from './types';

export const defaultPageSizes = [10, 25, 50, 100, AllItemsPerPage];
